import React from 'react';
import memoize from 'memoize-one';
import { ButtonTooltip, Icon } from '../../../components';

const columns = memoize(clickHandler => [
  {
    name: 'ENCUESTA',
    selector: 'survey',
    cell: item => item.survey?.label,
    sortable: true,
    grow: '5'
  },
  {
    name: 'ACCIONES',
    cell: item => {
      const isAnswered = item.status === 'answered';
      return (
        <ButtonTooltip
          onClick={() => clickHandler(item, 'answer')}
          variant={isAnswered ? 'circle-info' : 'circle-warning'}
          className="btn-circle"
          size="sm"
          disabled={item.enrolled}
          text={isAnswered ? 'Ver Respuestas' : 'Responder'}
        >
          <Icon icon={isAnswered ? 'eye' : 'pencil'} />
        </ButtonTooltip>
      );
    },
    ignoreRowClick: true,
    grow: '1.5',
    minWidth: '185px',
    center: true
  }
]);

export default columns;
